import NewUserContainer from "./NewUserContainer";

export default NewUserContainer;